import logger from '@/lib/logger'

/**
 * Import content file(s).
 *
 * This is where the magic of locale aware importing will exist...
 *
 * @param {[string]} requests an Array of routes
 */
export default async requests => {
  let page = {}

  async function processRequest(route) {
    let isObject = typeof route === 'object'

    let path = isObject ? route.path : route
    let slug = isObject ? route.slug : route.split('/').pop()

    logger.debug(`[content]: Importing ${path}.json @ en`)

    const response = await import(`@/content/${path}.json`)

    if (!response) {
      throw new Error(`Could not load ${slug}. Response is undefined`)
    }

    // namespace multi-page requests
    if (requests.length > 1) {
      page[slug] = response.default

      if (!page.meta && route === requests[0]) {
        page.meta = response.default.meta
      }
    } else {
      // keep single requests easy to access
      page = response.default
    }
  }

  await Promise.all(requests.map(request => processRequest(request)))

  return page
}
